import React, { useEffect } from 'react';
import AppRouter from './AppRouter';
import './index.css';
import { AuthProvider } from './AuthContext';
import { LoaderProvider, useLoader } from './components/context/LoaderContext';
import { ThemeProvider } from './components/context/ThemeContext';
import Loader from './components/common/Loader';
import { initializeLoaderControl } from './services/api';

// This wrapper component gives access to the LoaderContext
const AppWithLoader = () => {
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    initializeLoaderControl({ showLoader, hideLoader });
  }, []);

  return (
    <>
      <Loader />
      <AppRouter />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <LoaderProvider>
        <AuthProvider>
          <AppWithLoader />
        </AuthProvider>
      </LoaderProvider>
    </ThemeProvider>
  );
}

export default App;
